import React, { useRef, useEffect, useState } from "react";
import Title from "../layouts/Title";
import { projectOne, projectTwo, projectThree } from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setVisibleCards((prev) => [...prev, index]);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentCards = cardsRef.current;
    currentCards.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      currentCards.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  const projectData = [
    {
      title: "AI-Powered WooCommerce Conversational Chatbot",
      des: "Developed an n8n-automated chatbot for WordPress/WooCommerce, providing real-time support via live store data using RAG and NLU for context-aware interactions.",
      src: projectOne,
      tags: ["WordPress", "RAG", "n8n"],
    },
    {
      title: "AI-Assisted Rapid UI/UX Prototyping",
      des: "Led full cycle from market analysis to a live UI prototype on Vercel using AI-powered tools for accelerated design and development.",
      src: projectTwo,
      tags: ["UI/UX", "Figma", "AI"],
    },
    {
      title: "Lazychat eCommerce Management Tool",
      des: "Contributed to developing a responsive admin panel for omnichannel order and customer management across multiple platforms.",
      src: projectThree,
      tags: ["React", "PHP", "MySQL"],
    },
    {
      title: "Print-on-Demand Integration with WooCommerce",
      des: "Developed custom integration between WooCommerce and print-on-demand services for automated order fulfillment and product customization.",
      src: null,
      tags: ["WooCommerce", "API", "Integration"],
    },
  ];

  return (
    <section id="projects" className="w-full py-24 section-divider">
      <div className="max-w-screen-xl mx-auto px-6">
        <Title title="Project Showcase" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 py-6">
          {projectData.map((project, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              data-index={index}
              className="opacity-0 transform translate-y-[30px] transition-all duration-700"
              style={{
                opacity: visibleCards.includes(index) ? 1 : 0,
                transform: visibleCards.includes(index)
                  ? "translateY(0)"
                  : "translateY(30px)",
                transitionDelay: `${index * 150}ms`,
              }}
            >
              <ProjectsCard
                title={project.title}
                des={project.des}
                src={project.src}
                tags={project.tags}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
